import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BasketAdd } from '../_models/basketadd';
import { BasketLine } from '../_models/basketline';
import { BasketService } from '../_services/basket.service';
import { CustomerService } from '../_services/customer.service';

@Component({
    selector: 'app-basket',
    templateUrl: './basket.component.html',
    styleUrls: ['./basket.component.css'],
    standalone: false
})
export class BasketComponent implements OnInit {
  basketlines!: BasketLine[];
  total!: number;
  totalcore!: number;
  totalitems!: number;
  orderForm!: FormGroup;
  errorMessage!: string;
  alloworderdeletion!: boolean;


  constructor(private basketService: BasketService, private fb: FormBuilder, private toastr: ToastrService, private router: Router, public customerService: CustomerService) { }

  ngOnInit(): void {
   
    this.initializeForm();

    this.customerService.currentUser$.subscribe(user => { 
      this.alloworderdeletion = user?.allowOrderDeletion;   
      //console.log(user.username); 
      //console.log("allow deletion:" + this.alloworderdeletion);
    });

    this.load();
    this.total = 0;
    this.totalcore = 0;
    this.totalitems = 0;

    
  }

  initializeForm(){
    this.orderForm = this.fb.group({
      'orderlijn': this.fb.array([]),
      'opmerkingen': new FormControl('', [Validators.maxLength(20)]),
      'yourreference': new FormControl('')
    })
  }

  load()  {
    this.basketService.getAll().subscribe({
      next: lines => {
        this.basketlines = lines;
        
        lines.forEach(element => {
          const group = this.fb.group({
            fullline: new FormControl(element),
            qty: new FormControl(element.aantal),          
            totaallijn : new FormControl(element.aantal * element.verkoopprijs)
          });
          //console.log("line " + group.value.qty);
          (<FormArray>this.orderForm.get('orderlijn')).push(group);
        })
        this.getTotal();      
      },
      error: err => this.errorMessage = err
    });
  

  }  

  getTotal(){
    this.total = 0;
    this.totalcore = 0;
    this.totalitems = 0;

    this.basketlines.forEach(e => {
      this.totalitems = this.totalitems + (e.aantal * e.verkoopprijs);
      this.totalcore = this.totalcore + (e.aantal * e.statiegeld);
      this.total = this.totalitems + this.totalcore;
    })
  }

  update()  {
    //console.log("update");
    (<FormArray>this.orderForm.get('orderlijn')).controls.forEach(element =>{
      if (element.value.qty != element.value.fullline.aantal)
      {
        //console.log(element.value.fullline.xref);
        let basketadd : BasketAdd = {
          xref : element.value.fullline.xref,
          aantal : element.value.qty*1,
          prijs : element.value.fullline.verkoopprijs,
          merk : element.value.fullline.merk,
          promotionId : 0
        }
        element.value.fullline.aantal = element.value.qty;
        element.value.totaallijn = element.value.qty * element.value.fullline.verkoopprijs;
        element.setValue(element.value);

        this.basketService.Update(basketadd).subscribe(() => {
          this.toastr.success("Quantity updated");
          this.getTotal();
        })

      }
    });
  }

  deleteRegel(index: number){

    let basketline : BasketLine;
    const fulllineControl = (<FormArray>this.orderForm.get('orderlijn')).at(index).get("fullline");
    basketline = fulllineControl?.value;

    let basketdelete : BasketAdd = {
      xref : basketline.xref,
      prijs : basketline.verkoopprijs,
      merk : basketline.merk,
      aantal : 0,
      promotionId : 0
    }

    this.basketService.Update(basketdelete).subscribe(() => {
      this.toastr.success("Line deleted");
      (<FormArray>this.orderForm.get('orderlijn')).removeAt(index);
      
      this.load();
    })
  }

  deleteOrder(){
    (<FormArray>this.orderForm.get('orderlijn')).controls.forEach(element =>{

        //console.log(element.value.fullline.xref);
        let basketdelete : BasketAdd = {
          xref : element.value.fullline.xref,
          aantal : 0,
          prijs : element.value.fullline.verkoopprijs,
          merk : element.value.fullline.merk,
          promotionId : 0
        }

        this.basketService.Update(basketdelete).subscribe(() => {
          this.toastr.success("Line Deleted");
          this.load();
        })

      
    });

    
  }

  getControlLabel(i: number, type: string){
    if (i === null)
    {
      console.log('i is undefined.');
      return 0;
    }
    try {
      const control = (<FormArray>this.orderForm.get('orderlijn')).at(i).get(type);
      return control?.value;
    } catch (e) {
      console.error("i:" + (i ?? "undefined") + " error: " + e);
    }

    
   }

  sendOrder(){
    //console.log("send order");
    this.basketService.SendOrder(this.orderForm.value.opmerkingen, this.orderForm.value.yourreference);

    if (this.basketService.errorMessage === undefined || this.basketService.errorMessage === "")
    {
      this.toastr.success("Order has been sent.");
      this.router.navigateByUrl('/ordersend');
    }
  }

}
